/**
 * 결제 승인 API
 * FSD: features/subscription/payment-result/api
 */

import { apiClient } from '@/shared/api/client';

export interface ApprovalData {
  AuthResultCode: string;
  AuthResultMsg: string;
  TxTid: string;
  AuthToken: string;
  PayMethod?: string;
  MID: string;
  Moid: string;
  Amt: string;
  NextAppURL: string;
  NetCancelURL: string;
}

export interface ApprovalResponse {
  success: boolean;
  message: string;
  data?: {
    TID: string;
    resultCode: string;
    resultMsg: string;
    amount: number;
  };
}

class PaymentApprovalAPI {
  async approvePayment(data: ApprovalData): Promise<ApprovalResponse> {
    try {
      const response = await apiClient.post<ApprovalResponse>(
        '/v1/payment/approve',
        data
      );
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || '결제 승인 실패');
    }
  }
}

export const paymentApprovalAPI = new PaymentApprovalAPI();
